// extracted by mini-css-extract-plugin
export default {"divider":"divider_divider__3Rihd"};